import { IQpThrottleConfig, IQpThrottleQueue, IQpPromiseThrottleService, IQpPromiseThrottleFactory } from "./interface/index";

export function QpPromiseThrottle($timeout: angular.ITimeoutService, $q: angular.IQService): IQpPromiseThrottleFactory {

    let groupQueue: IQpThrottleQueue<IQpPromiseThrottleService> = {};

    return function <T, TArgs = any>(throttleFn: (...args: TArgs[]) => angular.IPromise<T>, options?: Partial<IQpThrottleConfig>) {

        /**
         * 默认配置
         */
        let defaultConfig: IQpThrottleConfig = {
            leading: false,
            trailing: true,
            group: "global",
            delay: 0,
            breakWhenReject: true
        };

        /**
         * 运行时配置
         */
        let config: IQpThrottleConfig = angular.merge({}, defaultConfig, options);
        /**
         * 执行函数
         * @param resolveHandler 
         * @param rejectHandler 
         * @returns 
         */
        let runThrottle = function (...args: TArgs[]) {
            throttleFn(...args).then((value) => {
                deferred.resolve(value);
            }, (reason: any) => {
                deferred.reject(reason);
            }).catch((reason: any) => {
                deferred.reject(reason);
            }).finally(() => {
                //执行队列里的函数
                let gq = groupQueue[config.group];

                if (gq && gq.running == undefined && gq.queue.length > 0) {
                    let next = gq.queue.shift();

                    gq.running = undefined;

                    $timeout(() => {
                        if (next) {
                            gq.running = next.service;
                            next.service.run(next.arg);
                        }
                    }, config.delay);
                };
            });
        }

        /**
         * 当前Service运行的promise
         */
        let deferred = $q.defer<unknown>();

        let throttled: IQpPromiseThrottleService = {
            run: function (...args: TArgs[]) {
                //如果是直接执行的
                if (config.leading) {
                    runThrottle(...args);
                } else {
                    //如果不是直接执行的，要么就通过队列执行，要么就丢弃

                    //通过队列执行
                    if (config.trailing !== false) {
                        let gq = groupQueue[config.group];

                        if (gq == undefined || gq.running == undefined || gq.queue.length == 0) {
                            //如果分组中没有正在执行的函数，则直接执行
                            groupQueue[config.group] = {
                                running: throttled,
                                queue: []
                            }

                            runThrottle(...args);
                        } else {
                            //如果分组中有正在执行的函数，则放到队列里
                            if (gq.queue.length > 0 && gq.queue[0].service != throttled) {
                                if (gq.queue[gq.queue.length - 1].service != throttled) {
                                    gq.queue.push({ arg: args, service: throttled });

                                    groupQueue[config.group] = gq;
                                    console.log(gq);
                                };
                            }
                        }
                    } else {
                        //丢弃不执行
                    }
                }

                return deferred.promise;
            },
            cancel: function () {
                deferred.reject({ canceled: true });
            }
        }

        return throttled;
    };
};